import { createSlice, createSelector, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

// Define the new state interface
export interface AboutStateType {
    image: string;
}

// Initial state
const initialState: AboutStateType = {
    image: '',
};

// Create slice
export const aboutSlice = createSlice({
    name: 'about',
    initialState,
    reducers: {
        setAboutImage: (state, action: PayloadAction<string>) => {
            state.image = action.payload;
        },
        clearAboutImage: (state) => {
            state.image = '';
        },
    },
});

// Export actions
export const {
    setAboutImage,
    clearAboutImage
} = aboutSlice.actions;

// Export reducer
export default aboutSlice.reducer;

// Selector
export const aboutSelector = (state: RootState) => state.about;

export const aboutImageSelector = createSelector(
    [aboutSelector],
    (state) => state.image
);
